import JSEncrypt from 'jsencrypt';

const PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDv9FUc3/IibxXbCAFHlO3o7ufhUkxeiOJFjnL30kXkgzCxsvNf6rGqKtoy2xKsVzgmClLvC6I4BtMbGS84Y/ssCk7bhW8VJ0ZGU4rdBkv9JetpTuABoG1U/gxxu1IEoW3h5shA1c/YyWQO7qYOp8XjqJJhPOD8l647DaKXEhKsbwIDAQAB';

export function encryptPassword(password: string) {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(PUBLIC_KEY);
  const encrypted = encrypt.encrypt(password);
  return encrypted;
}